import * as React from 'react'
import IframeContainer from '../../Iframe/IframeContainer'

export type Props = {
  id: string
  src: string
}

const dummyFun = (f: any) => f

export const FunctionalMonitoringIframe: React.SFC<Props> = ({id, src}: Props) => (
  <IframeContainer
    id={id}
    src={src}
    onIframeStateChange={dummyFun}
  />
)
